// extracted by mini-css-extract-plugin
export var home__productsImage = "homeProducts-module--home__productsImage--dZH9E";